import React from 'react';
import { connect } from 'react-redux';
import { CONFIG } from '../../../../config';
import {cekCookies} from '../../../../actions';
import __ from 'lodash';
import LoaderModal from '../../../modal/LoaderModal';
import Guru from './Guru';

class FormEdit extends React.Component {
    constructor (props){
        super(props);
        this.state={
            usernameGuru:'',
            namaGuru:'',
            emailGuru:'',
            handphoneGuru:'', 
            passwordGuru:'', 
            idGuru:'', 
            statusGuru:'',            
        }
    }

    dismissModal = ()=>{
        return(
            this.setState({modalShowing:false})
        )
    }
    
    showModal(){
        return(
            <div className="modal fade" id="editGuru">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content"> 
                        <div className="modal-header">
                            <h4 className="modal-title">Edit Guru</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        
                        <form id="form-tambah" onSubmit={this.tambah} responseMessage={this.state.responseMessage}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-4">
                                        <label>Nama Guru</label>
                                        {this.state.namaGuru=='' && <input type="text" className="form-control" value={this.props.dataGuru.namaGuru} onChange={this.namaGuruOnChange} placeholder="Nama Guru" required autoComplete="off"/>}                                        
                                        {this.state.namaGuru!='' && <input type="text" className="form-control" value={this.state.namaGuru} onChange={this.namaGuruOnChange} placeholder="Nama Guru" required autoComplete="off"/>}
                                        
                                    </div>
                                    <div className="col-md-4">
                                        <label>Username Guru</label>
                                        {this.state.usernameGuru=='' && <input type="text" className="form-control" value={this.props.dataGuru.usernameGuru} onChange={this.usernameGuruOnChange} placeholder="Username Guru" disabled autoComplete="off"/>}  
                                        
                                    </div>
                                    <div className="col-md-4">
                                        <label>Email Guru</label>
                                        {this.state.emailGuru=='' && <input type="email" className="form-control" value={this.props.dataGuru.emailGuru} onChange={this.emailGuruOnChange} placeholder="Email Guru" required autoComplete="off"/>}                                        
                                        {this.state.emailGuru!='' && <input type="email" className="form-control" value={this.state.emailGuru} onChange={this.emailGuruOnChange} placeholder="Email Guru" required autoComplete="off"/>}
                                        
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <label>No Telpon</label>
                                        {this.state.handphoneGuru=='' && <input type="text" className="form-control" value={this.props.dataGuru.handphoneGuru} onChange={this.telponGuruOnChange}  placeholder="Nomor Telfon" required autoComplete="off"/>}                                          
                                        {this.state.handphoneGuru!='' && <input type="email" className="form-control" value={this.state.handphoneGuru} onChange={this.telponGuruOnChange} placeholder="Nomor Guru" required autoComplete="off"/>}
                                        
                                    </div>
                                    <div className="col-md-4">
                                        <label>Password</label>                                          
                                        <input type="password" className="form-control" value={this.state.passwordGuru} onChange={this.passwordGuruOnChange}  placeholder="Password Guru" required min="4"/>
                                        
                                    </div>
                                    <div className="col-md-4">
                                        <label>Status Guru</label>
                                        <select className="form-control" value={this.state.statusGuru} onChange={this.statusGuruOnChange}  required>
                                            <option value="" selected>-- Pilih Status --</option>
                                            <option value="0">Aktif</option>
                                            <option value="1">Tidak Aktif</option>
                                        </select>
                                       
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger float-left" data-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary">Simpan</button>
                            </div>
                        </form>

                    </div>
                </div>
            </div> 
        );
    }

    // HANDLE CHANGE INPUT
    namaGuruOnChange = (event) =>{
        this.setState({namaGuru: event.target.value})
    }
    usernameGuruOnChange = (event) => {
        this.setState({usernameGuru: event.target.value})
    }
    emailGuruOnChange = (event) => {
        this.setState({emailGuru: event.target.value})
    }
    telponGuruOnChange = (event) => {
        this.setState({handphoneGuru: event.target.value})
    }
    passwordGuruOnChange = (event) => {
        this.setState({passwordGuru: event.target.value})
    }
    statusGuruOnChange = (event) => {
        this.setState({statusGuru: event.target.value})
    }



    async componentDidMount(){
        this.setState({ isFetching: true} );
        await this.props.cekCookies();
        this.setState({ isFetching: false} );
    }

    async componentDidUpdate(){
        console.log(this.props.dataGuru.namaGuru)
    }
    async isiState(){
            this.setState({namaGuru:this.props.dataGuru.namaGuru})
            // this.setState({emailGuru:this.props.dataGuru.emailGuru})
            // this.setState({handphoneGuru:this.props.dataGuru.handphoneGuru})
            // this.setState({emailGuru:this.props.dataGuru.emailGuru})
            // this.setState({idGuru:this.props.dataGuru.idGuru})
            // this.setState({statusGuru:this.props.dataGuru.statusGuru})


    }

    render(){
        return (
            <div>
                {this.isiState()}
            </div>            
            // if(){}
            // <div className="modal fade" id="editGuru">
            //     <div className="modal-dialog modal-lg">
            //         <div className="modal-content"> 
            //             <div className="modal-header">
            //                 <h4 className="modal-title">.......................</h4>
            //                 <button type="button" className="close" data-dismiss="modal">&times;</button>
            //             </div>                        
            //                 <div className="modal-body">
            //                 </div>

            //                 <div className="modal-footer">
            //                     <button type="button" className="btn btn-danger float-left" data-dismiss="modal">Close</button>
            //                     <button type="submit" className="btn btn-primary">Simpan</button>
            //                 </div>
            //         </div>
            //     </div>
            // </div>           
            
        )
    }
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
        responseMessage: state.responseMessage
    }
}

export default connect(mapStateToProps,{cekCookies})(FormEdit);